import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import { useFormState } from 'react-final-form';

import LanguageConverterV2 from '@careerstart/wae-common/src/main/helperFunction/LanguageConverterV2';
import { Box, Typography, useMediaQuery } from '@mui/material';
import { useTheme } from '@mui/material/styles';

import { buildFormField } from '../../../../../components/Form/formFieldFactory';
import { calculateWeeksBetweenDates } from '../../utils/recurringTwoWeeksHelpers';
import FormSectionDescription from '../CustomComponents/FormSectionDescription';
import FormSectionHeader from '../CustomComponents/FormSectionHeader';
import { dateRangeField } from '../FormFieldData/CreateJobFields';

const JobPostingDuration = ({ wrapperSx }) => {
  const formState = useFormState();
  const theme = useTheme();
  const smallScreen = useMediaQuery(theme.breakpoints.down('sm'));

  const dateRange = formState?.values?.dateRange || [null, null];
  const [startDate, endDate] = dateRange;

  const weeks = useMemo(() => calculateWeeksBetweenDates(startDate, endDate), [startDate, endDate]);

  return (
    <Box
      sx={{
        width: '100%',
        ...wrapperSx,
      }}
    >
      <FormSectionHeader messageKey="job.create.recurringTwoWeeks.postingDuration.header" />
      <FormSectionDescription messageKey="job.create.recurringTwoWeeks.postingDuration.desc" />
      <Box
        sx={{
          display: 'flex',
          width: '100%',
          flexDirection: smallScreen ? 'column' : 'row',
          gap: theme.spacing(1),
          alignItems: smallScreen ? 'stretch' : 'flex-start',
        }}
      >
        <Box sx={{ display: 'flex', flex: 1, gap: theme.spacing(1) }}>
          {buildFormField(dateRangeField())}
        </Box>
        {weeks > 0 && (
          <Box
            sx={{
              display: 'flex',
              alignItems: 'center',
              alignSelf: 'center',
              padding: theme.spacing(1.5, 2),
              backgroundColor: theme.palette.grey[100],
              borderRadius: theme.spacing(1),
              minWidth: smallScreen ? '100%' : '200px',
              justifyContent: 'center',
            }}
          >
            <Typography
              sx={{
                fontWeight: theme.typography.fontWeightBold,
                fontSize: theme.typography.body1.fontSize,
                color: theme.palette.text.primary,
              }}
            >
              {LanguageConverterV2('job.create.recurringTwoWeeks.postingDuration.display', {
                weeks,
              })}
            </Typography>
          </Box>
        )}
      </Box>
    </Box>
  );
};

JobPostingDuration.propTypes = { wrapperSx: PropTypes.shape({}) };

export default JobPostingDuration;
